/* src/app/users/user-profile/user-profile.component.css */
:host ::ng-deep .p-panel .p-panel-header {
  background-color: var(--surface-100);
  border-bottom: 1px solid var(--surface-200);
}
:host ::ng-deep .p-panel .p-panel-content {
  background-color: var(--surface-0);
}
label {
  display: block;
  margin-bottom: 0.25rem;
  color: var(--text-color-secondary);
  font-size: 0.875rem;
}
p,
span {
  color: var(--text-color);
}
/*# sourceMappingURL=user-profile.component-BBVVIF7I.css.map */
